import * as React from "react";

export const SvgHome = (props) => (
	<svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			clipRule="evenodd"
			d="M2.3 7.45 9.95 1.5l7.65 5.95v9.35a1.7 1.7 0 0 1-1.7 1.7H4a1.7 1.7 0 0 1-1.7-1.7V7.45Z"
			stroke={props.color ?? "#A8A8A8"}
			strokeWidth={1.5}
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M7.4 18.5V10h5.1v8.5"
			stroke={props.color ?? "#A8A8A8"}
			strokeWidth={1.5}
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
